import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

import { AgentPaths, BasePaths, MemberPaths } from '../constants/routes';
import { SessionService } from '../services/storage/session.service';
import { Session } from '../models/session';
import { LocationStrategy } from '@angular/common';

@Component({
    selector: 'mwp-version-error',
    templateUrl: './version-error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VersionErrorComponent implements OnInit {
    public currentVersion = environment.appVersion;
    public apiVersion: string;
    public isVersionError: boolean;
    public isLoggedIn: boolean;
    public title: string;
    public message: string;
    public buttonLabel: string;

    constructor(
        private sessionService: SessionService,
        private location: LocationStrategy,
        private router: Router,
    ) {
        this.sessionService.$Session.subscribe((session: Session) => {
            if (!session.isVersionIncompatible) {
                if (session.isLoggedIn) {
                    if (session.isAgent && !session.isMember)
                        this.router.navigateByUrl(AgentPaths.CounselorMember);
                    else
                        this.router.navigateByUrl(MemberPaths.Dashboard);
                } else {
                    this.redirectHome();
                }
            }
        });

        // Disables browser back function
        history.pushState(null, null, window.location.href);
        this.location.onPopState(() => {
            history.pushState(null, null, window.location.href);
        });
    }

    ngOnInit() {
        this.apiVersion = this.sessionService.session.operatingMode.version;
        this.isLoggedIn = this.sessionService.session.isLoggedIn;
    }

    public redirectHome() {
        let l_Path: string;
        if (this.sessionService.session.isAgent)
            l_Path = BasePaths.Counselors;
        else
            l_Path = BasePaths.Members;

        if(this.sessionService.session.isLoggedIn)
            this.sessionService.logout();

        this.sessionService.clear();

        this.router.navigateByUrl(l_Path).then(() => {
            location.reload();
        });
    }
}